import React from 'react';
import { FaTimes, FaEdit } from 'react-icons/fa';
import dayjs from 'dayjs';

const DepartmentViewModal = ({ open, onClose, department, onEdit }) => {
  if (!open || !department) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-800">Department Details</h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              <FaTimes className="text-xl" />
            </button>
          </div>

          <div className="space-y-4">
            <div className="border-b pb-4">
              <h3 className="text-lg font-semibold text-gray-700 mb-2">Basic Information</h3>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-sm text-gray-500">Department Code</p>
                  <p className="font-medium">{department.DepartmentCode}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Department Name</p>
                  <p className="font-medium">{department.DepartmentName}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Status</p>
                  <p className="font-medium">
                    <span className={`inline-block px-2 py-1 rounded-full text-xs font-bold
                      ${department.IsActive ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`}>
                      {department.IsActive ? 'Active' : 'Inactive'}
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div className="border-b pb-4">
              <h3 className="text-lg font-semibold text-gray-700 mb-2">Timestamps</h3>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-sm text-gray-500">Created At</p>
                  <p className="font-medium">
                    {department.CreatedAt ? dayjs(department.CreatedAt).format('DD MMM YYYY, HH:mm') : '-'}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Created By</p>
                  <p className="font-medium">{department.CreatedBy || '-'}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Updated At</p>
                  <p className="font-medium">
                    {department.UpdatedAt ? dayjs(department.UpdatedAt).format('DD MMM YYYY, HH:mm') : '-'}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Updated By</p>
                  <p className="font-medium">{department.UpdatedBy || '-'}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 flex justify-end space-x-3">
            <button
              onClick={() => onEdit && onEdit(department)}
              className="px-4 py-2 bg-[#2c3e50] text-white rounded-lg hover:bg-[#34495e] transition-colors flex items-center gap-2"
            >
              <FaEdit />
              Edit Department
            </button>
            <button
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepartmentViewModal;